module.exports = __webpack_public_path__ + "static/media/af.1e73c9ee.svg";